// extracted by mini-css-extract-plugin
export default {"mainForm":"styles_mainForm__4quJe","mainFormContent":"styles_mainFormContent__ZANWF","formContainer":"styles_formContainer__J9Tp3"};